import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { Divider } from '@pets-ui/Divider/Divider'
import { FooterStack } from '@pets-ui/FooterStack/FooterStack'
import { useCart } from '../CartProvider/CartProvider'
import { FooterCheckout } from '../FooterCheckout/FooterCheckout'
import { FooterCoupon } from '../FooterCoupon/FooterCoupon'
import { FooterReminder, type FooterReminderProps } from '../FooterReminder/FooterReminder'

export interface CartFooterProps {
  isAiCart?: boolean
}

export const CartFooter = (props: CartFooterProps) => {
  const { isAiCart } = props
  const { projectCode, countryCode, currency, campaignCodeFromUrl, campaignId, platform } = useCart()
  const { items: cartItems, updateAllCartItemsButlerChecked } = useFpB2bCartService(campaignId, platform)

  const handleCheckAllChange: FooterReminderProps['onCheckAllChange'] = (e) => {
    updateAllCartItemsButlerChecked(e.target.checked)
  }

  return (
    <FooterStack>
      {/* 此功能先關閉，待設計更新
      <FooterShippings
        totalAmount={campaignCouponCalculateResult?.total_after_discount}
        currency={currency}
        shippingMethods={campaignCouponCalculateResult?.shipping_methods}
        positionMode="absolute"
      /> */}
      {isAiCart && <FooterReminder cartItems={cartItems} onCheckAllChange={handleCheckAllChange} />}
      <FooterCoupon
        projectCode={projectCode}
        campaignId={campaignId}
        countryCode={countryCode}
        campaignCode={campaignCodeFromUrl}
        currency={currency}
        elevation={isAiCart ? 0 : undefined}
      />
      <Divider />
      <FooterCheckout elevation={0} />
    </FooterStack>
  )
}
